document.addEventListener("DOMContentLoaded", function () {
    BOLD.common.eventEmitter.on("BOLD_OPTIONS_option_products_loaded", () => {
        setTimeout(() => {
            const atcInput = document.querySelector(".addtocart.bold_clone");
            atcInput.classList.remove("bold_disabled");
        }, 1000);
    });
});